'use strict';

module.exports = require('./es2015');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/es6.js
// module id = 27
// module chunks = 0